<div class="mt-2 panel-footer text-center">
  <span class="btn btn-secondary pull-left mt-2">
    {{"Common.SearchActionsAndDetailsActions.SelectedRows" | translate}} - {{search.selectedRows.length}}
    </span>
  <span class="btn btn-secondary pull-right mt-2">    
    {{"Common.SearchActionsAndDetailsActions.TotalRows" | translate}} - {{search.allRecordCountWithFilter}}
    </span>  
</div>